import { render, staticRenderFns } from "./MapLuxItem.vue?vue&type=template&id=8b773d90"
import script from "./MapLuxItem.vue?vue&type=script&lang=js"
export * from "./MapLuxItem.vue?vue&type=script&lang=js"
import style0 from "./MapLuxItem.vue?vue&type=style&index=0&id=8b773d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports